import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "vowos_session_token";

export const api = axios.create({
  baseURL: API,
  // Bearer token via localStorage is the canonical auth channel (mobile-friendly,
  // ITP-proof). Cookies still work as a fallback on same-origin requests without
  // needing `withCredentials: true`, which triggers credentialed-CORS rules that
  // iOS Safari rejects when combined with Access-Control-Allow-Origin: *.
  withCredentials: false,
  timeout: 20000,
});

// Attach Bearer from localStorage on every request.
// Mobile Safari blocks third-party cookies, so we rely on Authorization header.
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    /* ignore — localStorage may be disabled */
  }
  return config;
});

// Clear invalid tokens on 401 so UI can recover cleanly.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* noop */ }
    }
    return Promise.reject(err);
  }
);

export const saveSessionToken = (t) => {
  try { localStorage.setItem(TOKEN_KEY, t); } catch (e) { /* noop */ }
};
export const clearSessionToken = () => {
  try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* noop */ }
};

export const formatINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

/**
 * BUG FIX — attach to every `<input type="number">` used for currency,
 * quantity, or any other value where silent drift is unacceptable.
 * Blurs the input the instant a wheel event fires, so the browser's
 * native "scroll-decrements-number" behavior never fires. Combine
 * with the global CSS that hides spinner arrows for total safety.
 * Usage:  <input type="number" onWheel={blurOnWheel} ... />
 */
export const blurOnWheel = (e) => {
  // Blur removes focus → wheel event stops mutating the input.
  e.currentTarget.blur();
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const now = Date.now();
  const s = Math.floor((now - then) / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};
